import { Button } from "antd";
import styled from "styled-components";
import { theme } from "../../../config";

export const ButtonStyled = styled(Button)`
  color: ${theme.colors.secondary};
  border: 2px solid ${theme.colors.secondary};
  border-radius: 4px;
  line-height: 0px;
  height: 25px;
  width: 75px;
  text-align: center;
  font-size: 14px;
  line-height: 0px;
  padding: 0 10px;

  &:hover {
    color: ${theme.colors.secondary};
    border: 2px solid ${theme.colors.secondary};
  }
  &:focus {
    color: ${theme.colors.secondary};
    border: 2px solid ${theme.colors.secondary};
  }
`;

export const RenderText = styled.span<{ isSuspended: boolean }>`
  ${(props) => props.isSuspended && `color: ${theme.colors.neutral.black4};`}
`;
